import { Radio, RadioProps } from "../Radio";

/**
 * @deprecated see RadioRAC with isCard prop
 */
export function RadioCard(props: RadioProps) {
  return <Radio {...props} card />;
}
